<cbc-container [isLoading]="isLoading" 
[showContainer]="!isLoading" 
title="Acesso Notificações"
description="Gerencie o envio de notificações para os usuários">
</cbc-container>

@if(!isLoading) {
<div class="container">
  <div class="card">
    <div class="card-header">
      <div class="card-title">Notificações Cadastradas</div>
      <div style="display: flex; gap: var(--spacing-sm);">
        <button mat-stroked-button (click)="notificationStreamSubscriptions()" class="btn btn-ghost">
          <mat-icon>list</mat-icon> Ver lista
        </button>
        <button mat-stroked-button (click)="notificationStreamCleanSubscriptions()" class="btn btn-ghost">
          <mat-icon>clear_all</mat-icon> Limpar lista
        </button>
        <button mat-fab extended color="primary" (click)="openNotificationDialog()" class="btn btn-primary">
          <mat-icon>add</mat-icon>
          Nova Notificação
        </button>
      </div>
    </div>
    
    <div class="card-body">
      @if(notifications.length === 0) {
      <div class="alert alert-info">
        <mat-icon>info</mat-icon>
        <div>
          <strong>Nenhuma notificação cadastrada</strong>
          <p>Clique no botão "Nova Notificação" para adicionar a primeira notificação.</p>
        </div>
      </div>
      }

      @for (item of notifications; track item.id) {
      <div class="card card-white notification-item">
        <div style="display: flex; gap: var(--spacing-md); align-items: flex-start;">
          <div style="flex: 1;">
            <div class="info-row">
              <span class="info-label">Título:</span>
              <span class="info-separator"></span>
              <span class="info-data">{{ item.title }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Mensagem:</span>
              <span class="info-separator"></span>
              <span class="info-data">{{ item.message }}</span>
            </div>
            <div style="display: flex; gap: var(--spacing-md); margin-top: var(--spacing-sm); flex-wrap: wrap;">
              <span class="badge badge-primary">ID: {{ item.id }}</span>
              <span class="badge" [ngClass]="item.global ? 'badge-success' : 'badge-cancelled'">
                {{ item.global ? 'Global' : 'Específico' }}
              </span>
              @if(item.packageType) {
              <span class="badge badge-primary">{{ item.packageType }}</span>
              }
              @if(item.sentAt) {
              <span class="badge badge-success">Enviado: {{ item.sentAt | date : "dd/MM/yyyy HH:mm" }}</span>
              }
            </div>
          </div>
          <div style="display: flex; gap: var(--spacing-sm);">
            <button mat-icon-button (click)="editNotification(item)" matTooltip="Editar">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="warn" (click)="deleteNotification(item.id!)" matTooltip="Excluir">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>
}